export function isExternalLink(link: string): boolean {
	return link.indexOf('://') > -1;
}
